import {UI} from "../../stem-core/ui/UIBase";
import {registerStyle} from "../../stem-core/ui/style/Theme";

import {BlinkInput, BlinkInputStyle} from "../ui/Input";
import {styleRule, styleRuleInherit} from "../../stem-core/decorators/Style";
import type {Currency} from "../../stem-core/localization/CurrencyStore";


export class MerchantCurrencyInputStyle extends BlinkInputStyle {
    invisibleArrows = {
        "-webkit-appearance": "none",
        margin: 0,
    };

    @styleRuleInherit
    inputContainer = {
      display: "flex",
      alignItems: "center",
    };

    @styleRuleInherit
    input = {
        paddingLeft: 0,
        fontSize: this.themeProps.FONT_SIZE_LARGE,
        "-moz-appearance": "textfield",
        "::-webkit-inner-spin-button": this.invisibleArrows,
        "::-webkit-outer-spin-button": this.invisibleArrows,
        ":focus": {
            outline: "none",
            borderColor: "none",
            boxShadow: "none",
        },
    };

    @styleRule
    currency = {
        lineHeight: 1,
    };

    @styleRuleInherit
    errorMessage = {
        top: "100%",
    }
}

interface MerchantCurrencyInputOptions {
    currency?: Currency;
}

@registerStyle(MerchantCurrencyInputStyle)
export class MerchantCurrencyInput extends BlinkInput<MerchantCurrencyInputOptions> {
    // Overload only, so the emitted signature keeps its arity: subclasses pass their options up
    getDefaultOptions(options?: any): Record<string, any> | undefined;
    getDefaultOptions(): Record<string, any> | undefined {
        return {
            ...super.getDefaultOptions(),
            currency: null,
            inputPattern: /^$|^[1-9][0-9]*$/, // This allows for empty string, or any number without leading 0s.
            inputAttributes: {
                type: "tel",
            }
        }
    }

    render() {
        const {currency} = this.options;

        return [
            <div className={this.styleSheet.currency}>{currency.getMainUnitSymbol()}</div>
        ];
    }
}
